import { useParams, Navigate, Link } from "react-router-dom";
import MarketingPage from "@/components/public/MarketingPage";
import { BookOpen, ArrowLeft } from "lucide-react";
import { ARTICLES } from "@/data/resources_articles";

export default function ResourceArticle() {
    const { slug } = useParams();
    const article = ARTICLES[slug];
    if (!article) return <Navigate to="/resources" replace />;
    return (
        <MarketingPage
            slug={`article-${slug}`}
            title={article.title}
            description={article.summary}
            canonical={`/resources/${slug}`}
            hero={article.title}
            sub={article.summary}
            disclaimer="This guide is organisational only. VAULT does not provide regulated financial, tax or legal advice."
        >
            <section className="max-w-3xl mx-auto px-6 pb-12" data-testid={`article-${slug}`}>
                <div className="flex items-center gap-2 text-[11px] text-stone-500 mb-6">
                    <BookOpen size={12} />
                    <span className="uppercase tracking-widest font-semibold">{article.category}</span>
                    <span>·</span>
                    <span>{article.readTime} read</span>
                </div>
                <article className="space-y-6">
                    {article.sections.map((s, i) => (
                        <section key={i}>
                            <h2 className="text-xl font-display text-stone-900 mb-2">{s.h}</h2>
                            <p className="text-[14.5px] leading-relaxed text-stone-700">{s.p}</p>
                        </section>
                    ))}
                </article>
                <Link to="/resources"
                      className="mt-10 inline-flex items-center gap-1 text-[12px] font-semibold text-amber-800"
                      data-testid="article-back">
                    <ArrowLeft size={11} /> More resources
                </Link>
            </section>
        </MarketingPage>
    );
}
